import * as R from "ramda";
import { object } from "prop-types";
import { graphql } from "gatsby";
import { extractRichText } from "../common/contentful-extract.jsx";

import RichTextPage from "../components/RichTextPage/RichTextPage.jsx";

const propTypes = {
  data: object.isRequired, // exported query below
};

const RichTextTemplate = (props) => {
  const data = R.compose(
    R.evolve({
      content: extractRichText,
    }),
    R.path(["contentfulRichTextPage"]),
  )(props.data);

  return <RichTextPage {...data} />;
};

RichTextTemplate.propTypes = propTypes;
export default RichTextTemplate;

// !! it's important that __typename and contentful_id is in there so renderRichText works!
// https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-source-contentful/src/rich-text.js
export const query = graphql`
  query ($id: String!) {
    contentfulRichTextPage(id: { eq: $id }) {
      title
      content {
        raw
        references {
          ...Link
          ...RichTextReferences
        }
      }
    }
  }
`;
